import {MultipartFile} from "../components/controls/multipart-files/multipart-file";
import {FormVariable, FormVariables} from "../interfaces/form-variables.interface";

export default class FormVariablesUtils {

  static getFormVariables(formData: { [key: string]: any }): FormVariables {
    const result: FormVariables = {variables: [], multipartFiles: []};
    for (const key in formData) {
      const value = formData[key];
      if (Array.isArray(value) && value.length > 0 && value[0] instanceof MultipartFile) {
        handleMultipartFiles(result, key, value);
      } else {
        result.variables.push({name: key, value});
      }
    }
    return result
  }

  static getBlob(variables: Array<FormVariable>): Blob {
    const variablesObject = mapVariablesToVariablesObject(variables);
    return new Blob([JSON.stringify(variablesObject, null, 2)], {type: 'application/json'});
  }

}

function handleMultipartFiles(result: FormVariables, variableName: string, multipartFiles: Array<MultipartFile>): void {
  const fileNameArray: Array<string> = [];
  multipartFiles.forEach((part) => {
    if (part instanceof MultipartFile) {
      result.multipartFiles.push(part);
      fileNameArray.push(part.fileNameWithPath);
    } else {
      throw new Error('The array contains a type other than File');
    }
  });
  result.variables.push({name: variableName, value: fileNameArray});
}

function mapVariablesToVariablesObject(variables: Array<FormVariable>): object {
  const variablesObject = {};
  if (variables && Array.isArray(variables)) {
    variables.forEach((variable) => {
      variablesObject[variable.name] = variable.value;
    });
  }
  return variablesObject;
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/utils/form-variables-utils.ts